export enum AuthTypeEnum {
    Custom = 1,
    OIDC = 2,
    NotAuthenticated = 3
}
